import {
  AfterViewInit,
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {Router} from '@angular/router';
import {finalize} from "rxjs/operators";

import {SimpleDialect} from "../../models/dialect.model";
import {LIST_TYPE, SearchParam} from "../../defines/client.const";
import {GetRegion2Css, GetRegion2Name} from '../../defines/desktop.const';
import {DialectBookmarkService} from "../../services/dialect/dialect-bookmark.service";
import {DialectHistoryService} from "../../services/dialect/dialect-history.service";
import {dialectLinkMixin} from "../../mixin/dialect-link.mixin";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {DynamicComponentService} from "../../services/dynamic-component/dynamic-component.service";


@Component({
  selector: 'app-dialect-item',
  template: `
    <ng-container *ngIf="dialect">

      <!-- #container 의 퀴치는 컴포는트의 가장 상위 첫번째 child 이어야 함 -->
      <ng-container #container></ng-container>

      <div class="other-head-box">

        <article class="place-list-layout">
          <div class="place-label-list">
            <div *ngIf="dialect.area1"
                 class="place-label-box main-type{{ GetRegion2Css(dialect.area1) }}"
                 [innerHTML]="GetRegion2Name(dialect.area1) | keepHtml"></div>

            <!-- div *ngIf="dialect.area2"
                 class="place-label-box sub-type{{ GetRegion2Css(dialect.area1) }}"
                 [innerHTML]="dialect.area2 | keepHtml"></div -->
          </div>
        </article>


        <div class="head-txt-box">
          <div class="txt-box"
               [innerHTML]="dialect.word | resize"></div>
        </div>

      </div>

      <div class="other-body-box">

        <div class="other-info-box">
          <div *ngIf="dialect.wordMore"
               class="other-info-item">

            <div class="other-subject-box">
              <div class="border-box">비슷한 말</div>
            </div>
            <div class="other-con-box">
              <div class="other-txt-box"
                   [innerHTML]="getMoreWords() | resize"></div>
            </div>
          </div>
          <div class="other-info-item">
            <div class="other-subject-box">
              <div class="border-box">뜻</div>
            </div>
            <div class="other-con-box">
              <div class="other-txt-box"
                   *ngFor="let meaning2 of dialect.getBreafMeanings(); let idx = index">
                <ng-container *ngIf="dialect.GetMeaning2Nth(idx)">
                  <div *ngIf="idx > 0"
                       class="meaning-num" >{{ idx }}.</div>
                  <div class="meaning-txt"
                       [innerHTML]="dialect.GetMeaning2Nth(idx) | resize">
                  </div>
                </ng-container>
              </div>
              <div *ngIf="dialect.getMoreMeanings() > 0"
                   class="other-txt-box">
                <div class="more-txt">
                  <{{ dialect.getMoreMeanings() }}개의 뜻이 더 있습니다.>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  `,
  styleUrls: ['./dialect-item.component.scss'],
})
export class DialectItemComponent extends dialectLinkMixin implements AfterViewInit {
  /**
   * TODO: dialectLinkMixin 제거 예정. 링크 팝업을 없애고 바로 해당 지방어로 이동하도록 처리.
   */
  @HostBinding('class') class = 'other-item-box';
  @HostBinding('class.detail-item-box')
  get isDetailItemBox(): boolean {
    return this.inDetail;
  }
  @HostBinding('class.show-navigation-arrow')
  get hasNavigationArrow(): boolean {
    return this.showNavigationArrow;
  }

  @Input() inDetail = false;
  @Input() showNavigationArrow = false;
  @ViewChild('container', {read: ViewContainerRef}) container!: ViewContainerRef;
  @Input() dialect?: SimpleDialect;
  @Input() linkPopup = false;
  @Output() viewInit: EventEmitter<SimpleDialect> = new EventEmitter<SimpleDialect>();

  protected readonly GetRegion2Css = GetRegion2Css;
  protected readonly GetRegion2Name = GetRegion2Name;

  private sendingBookmark = false;


  constructor(
    public override router: Router,
    public override dHistorySvc: DialectHistoryService,
    public override dynamicSvc: DynamicComponentService,
    protected bmSvc: DialectBookmarkService,
    protected globalEventSvc: GlobalEventService,
  ) {
    super(router, dHistorySvc, dynamicSvc);
  }

  ngAfterViewInit() {
    this.viewInit.emit(this.dialect);
  }

  @HostListener('click', ['$event'])
  public onClick($event: MouseEvent): void {
    console.log('DialectItemComponent::onClick()', this.dialect);

    if (!this.linkPopup) {
      return;
    }

    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    if (!this.dialect) {
      throw new Error('DialectItemComponent::onClick() dialect is null');
    }
    // this.OpenDialectLink(this.dialect.id, this.container).subscribe();

    if (this.dHistorySvc.getById(this.dialect.id) === null) {
      // 없으면 추가.
      this.dHistorySvc.addHistory(this.dialect.id);
    }
    const queryParams: SearchParam = {
      id: this.dialect.id,
    };
    this.router.navigate(['/dialect-list', LIST_TYPE.SERVER], {queryParams}).then();
  }

  protected ToggleBookmark($event: MouseEvent, dialect: SimpleDialect): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    if (this.sendingBookmark) {
      return; // 이미 보내고 있다.
    }
    this.sendingBookmark = true;
    dialect.bookmark = !dialect.bookmark;
    this.bmSvc.sendBookmark(dialect.id, dialect.bookmark).pipe(
      finalize(() => this.sendingBookmark = false)
    ).subscribe(
      data => console.log(data),
      err => console.error(err)
    );
  }

  protected getBmCss(dialect: SimpleDialect): string {
    if (this.sendingBookmark) {
      return 'ing';
    }
    return dialect.bookmark ? 'on' : '';
  }

  protected getMoreWords(): string {
    return this.dialect?.wordMore?.join(', ') || '';
  }
}
